import axios from 'axios'

const axiosInstance = axios.create({
  headers: { 'Content-Type': 'application/json; charset=utf-8', Accept: 'text/json' }
})

export const sourceAxios = axios.CancelToken.source()

export const webApiService = {
  getDelivered: async (data: {start: string, end: string, idSeller: number | null, region?: string | null, store?: string | null}) => {
    const url = `${import.meta.env.VITE_SERVICE_DASHBOARD_TRADEIN}getDelivered`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getByDate: async (data: {start: string, end: string, idSeller: number | null, region?: string | null, store?: string | null}) => {
    const url = `${import.meta.env.VITE_SERVICE_DASHBOARD_TRADEIN}getByDate`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getByType: async (data: {start: string, end: string, idSeller: number | null, region?: string | null, store?: string | null}) => {
    const url = `${import.meta.env.VITE_SERVICE_DASHBOARD_TRADEIN}getByType`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getByStore: async (data: {start: string, end: string, idSeller: number | null, region?: string | null, store?: string | null}) => {
    const url = `${import.meta.env.VITE_SERVICE_DASHBOARD_TRADEIN}getByStore`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getModelsByBrand: async (data: {start: string, end: string, idSeller: number | null, region?: string | null, store?: string | null}) => {
    const url = `${import.meta.env.VITE_SERVICE_DASHBOARD_TRADEIN}getModelsByBrand`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getTopTen: async (data: {start: string, end: string, idSeller: number | null, brand: string | null, region?: string | null, store?: string | null}) => {
    const url = `${import.meta.env.VITE_SERVICE_DASHBOARD_TRADEIN}getTopTen`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  getHistorical: async (data: {start: string, end: string, idSeller: number | null, region?: string | null, store?: string | null}) => {
    const url = `${import.meta.env.VITE_SERVICE_DASHBOARD_TRADEIN}getHistorical`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  downloadDelivered: async (data: {start: string, end: string, idSeller: number | null, region?: string | null, store?: string | null}) => {
    const url = `${import.meta.env.VITE_SERVICE_DASHBOARD_TRADEIN}downloadDelivered`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  },
  downloadDeliveredBoost: async (data: {start: string, end: string, idSeller: number | null, region?: string | null, store?: string | null}) => {
    const url = `${import.meta.env.VITE_SERVICE_DASHBOARD_TRADEIN}downloadDeliveredBoost`
    return await axiosInstance.request({ method: 'POST', url, data }).then((res: any) => res.data)
  }
}
